<script lang="ts" setup>
	export type BentCardContextClass = {
		base: string
		backgrounContainer: Partial<{
			base: string
			width: string
			height: string
			rounded: string
			rotate: string
			position: string
			bg: string
		}>
		element: Partial<{
			base: string
			width: string
			height: string
			display: string
			rounded: string
			position: string
			overflow: string
		}>
	}

	const configClass: BentCardContextClass = {
		base: 'relative',
		backgrounContainer: {
			base: '',
			width: 'max-w-[404px] w-full  min-w-[200px] sm:min-w-[404px]',
			height: 'h-[75%] ',
			rounded: 'rounded-2xl ',
			rotate: 'sm:-rotate-[6deg] -rotate-[2deg]',
			position: 'absolute -bottom-8 sm:-left-20 -left-10',
			bg: 'bg-main'
		},
		element: {
			base: '',
			width: 'sm:min-w-[404px] w-full  max-w-[249.45px]',
			height: 'sm:min-h-[512px]',
			display: ' flex flex-col justify-end',
			rounded: ' rounded-2xl',
			position: 'relative  top-20 right-0',
			overflow: 'overflow-hidden'
		}
	}
	const { backgrounContainer, base, element } = configClass
	defineProps<{
		ui?: Partial<BentCardContextClass>
	}>()
</script>
<template>
	<div :class="base">
		<div
			:class="[
				ui?.backgrounContainer?.base ?? backgrounContainer.base,
				ui?.backgrounContainer?.bg ?? backgrounContainer.bg,
				ui?.backgrounContainer?.height ?? backgrounContainer.height,
				ui?.backgrounContainer?.position ?? backgrounContainer.position,
				ui?.backgrounContainer?.rotate ?? backgrounContainer.rotate,
				ui?.backgrounContainer?.rounded ?? backgrounContainer.rounded,
				ui?.backgrounContainer?.width ?? backgrounContainer.width
			]"
		/>
		<div
			:class="[
				ui?.element?.base ?? element.base,
				ui?.element?.display ?? element.display,
				ui?.element?.height ?? element.height,
				ui?.element?.width ?? element.width,
				ui?.element?.overflow ?? element.overflow,
				ui?.element?.position ?? element.position,
				ui?.element?.rounded ?? element.rounded
			]"
		>
			<slot />
		</div>
	</div>
</template>

<style></style>
